<template>
    <div
        class="tw-flex tw-items-center tw-gap-2 tw-cursor-wait"
        :class="{
            'tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-white tw-opacity-75 tw-flex tw-items-center tw-justify-center tw-text-2xl':
                fill,
        }"
    >
        <i class="mdi mdi-loading mdi-spin tw-text-black"></i>
        <slot></slot>
    </div>
</template>
<script setup>
defineProps({
    fill: {
        type: Boolean,
        default: false,
    },
});
</script>
